/**
 * Main script for Tomek Walas Photos website
 * Handles common functionality across all pages
 */

// Mobile navigation toggle
document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu toggle
  const menuToggle = document.querySelector('.menu-toggle') as HTMLButtonElement;
  const navMenu = document.querySelector('.nav-menu') as HTMLElement;
  
  if (menuToggle && navMenu) {
    menuToggle.addEventListener('click', () => {
      navMenu.classList.toggle('open');
      menuToggle.classList.toggle('active');
      
      // Update aria-expanded attribute for accessibility
      const isExpanded = navMenu.classList.contains('open');
      menuToggle.setAttribute('aria-expanded', isExpanded.toString());
    });
  }
  
  // Dropdown menu for galleries
  const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
  
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const parent = (toggle as HTMLElement).closest('.dropdown');
      
      // Close other open dropdowns
      document.querySelectorAll('.dropdown').forEach(dropdown => {
        if (dropdown !== parent) {
          dropdown.classList.remove('open');
        }
      });
      
      // Toggle current dropdown
      parent?.classList.toggle('open');
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.dropdown')) {
      document.querySelectorAll('.dropdown').forEach(dropdown => {
        dropdown.classList.remove('open');
      });
    }
  });
  
  // Close mobile menu when clicking a link
  const navLinks = document.querySelectorAll('.nav-menu a');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      // Only close if it's mobile view (checking if menu toggle is visible)
      if (window.getComputedStyle(menuToggle).display !== 'none') {
        navMenu.classList.remove('open');
        menuToggle.classList.remove('active');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

// Handle current year in copyright
const yearSpan = document.querySelector('.copyright-year');
if (yearSpan) {
  yearSpan.textContent = new Date().getFullYear().toString();
}

// Export any functions that might be needed by other modules
export {};